<template>
  <div :class="$style.sectionFeatures">
    <div class="container section">
      <div v-for="(item, index) in list" class="feature-container" :class="{ 'row-reverse': index % 2 !== 0 }" :key="index">
        <div v-if="index % 2 !== 0" class="feature-content wow animate__animated animate__fadeInRight">
          <p class="sub-title">{{ item.subTitle }}</p>
          <h2 class="title">{{ item.title }}</h2>
          <div class="content-detail" v-html="item.content"></div>
        </div>
        <div v-else class="feature-content wow animate__animated animate__fadeInLeft">
          <p class="sub-title">{{ item.subTitle }}</p>
          <h2 class="title">{{ item.title }}</h2>
          <div class="content-detail" v-html="item.content"></div>
        </div>

        <div v-if="index % 2 !== 0" class="feature-img wow animate__animated animate__fadeInLeft">
          <img :src="item.img" alt="" />
        </div>
        <div v-else class="feature-img  wow animate__animated animate__fadeInRight">
          <img :src="item.img" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'animate.css'
import { WOW } from 'wowjs'

export default {
  data() {
    return {
      list: [
        {
          title: '24/7 線上線下整合預約',
          subTitle: 'Quick and Simple',
          content:
            '<p>處理預訂就交給Ding Beauty，讓您花更多時間專心提供美麗！<br />同時具備線上與線下的預訂功能，一方面讓客戶可以隨時透過網站、Line進行預約，減少電話漏接、訊息晚回造成丟單的狀況；<br />另一方面，管理後台清晰的行事曆排程，讓您輕鬆靈活地在空檔時段新增訂單，避免重複預訂！</p>',
          img: require('@assets/dingbeauty-images/basic-plan/system_01@1.png'),
        },
        {
          title: '了解會員與客戶們',
          subTitle: 'Happy Client',
          content: `<p class="start-text">會員管理</p><p>讓您的紀錄不僅只有聯繫方式和訂單資訊！<br />更有內部備註和標籤功能，讓您快速暸解會員，即便不同服務人員也可以即時了解過往互動！</p
    ><p class="start-text">客戶管理</p><p>您可以建立多位客戶檔案，來對應不同的客戶，滿足各種不同的需求。<br />並於每一次服務後記錄客戶狀況，增加與客戶關係的深度，讓客戶感受到您滿滿的貼心與用心。</p>`,
          img: require('@assets/dingbeauty-images/basic-plan/system_02@1.png'),
        },
        {
          title: '服務人員管理',
          subTitle: 'Employees ',
          content:
            '<p>依照每位服務人員的狀況，設定不同的服務項目與價格，讓員工之間可保有工作績效的隱私。<br>還可以讓人員隨時查看各自的日程安排，方便事前了解每一位預約的客戶，並於服務後清楚記錄客戶狀態。</p>',
          img: require('@assets/dingbeauty-images/basic-plan/system_03@1.png'),
        },
        {
          title: '彈性排班方式 人員輕鬆分配',
          subTitle: 'Scheduleing',
          content:
            '<p>獨家支援24小時全日排班，滿足各種靈活排班需求，無論是單日多段式排班、重複性排班，或是一次性排班，都能簡單設定。<br>並自動計算服務人員每月的排班時數，擺脫繁複人工計算時間。<br>亦有跨分店排班功能，不必煩惱如何安排跨店支援問題，讓您的管理事半功倍！</p>',
          img: require('@assets/dingbeauty-images/basic-plan/system_04@1.png'),
        },
        {
          title: '適用不同職位的權限',
          subTitle: 'User Roles',
          content: '<p>擁有多種專業清楚的分工與管理權限，讓您透過簡單的操作，有效分配職位權責！<br>輕鬆掌控員工的瀏覽操作權限，同時保有商業經營隱私，讓經營更加完善。</p>',
          img: require('@assets/dingbeauty-images/basic-plan/system_05@1.png'),
        },
      ],
    }
  },
  mounted() {
    this.$nextTick(() => {
      let wow = new WOW({
        live: false,
      })
      wow.init()
    })
  },
}
</script>

<style lang="scss" module>
$color-primary: #e3c192;

.sectionFeatures {
  :global {
    .feature-container {
      display: block;
      margin-bottom: 120px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .feature-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: url('~@assets/dingbeauty-images/home/background01@2.png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      text-align: center;
      margin-bottom: 1rem;

      .sub-title {
        color: $color-primary;
        font-size: 16px;
      }

      .title {
        font-size: 30px;
        margin-bottom: 2rem;
      }
      .content-detail {
        p {
          font-size: 14px;
          line-height: 1.7;
          color: #545662;
          margin-bottom: 24px;
        }
      }
    }

    .start-text {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      color: #e3c192 !important;

      &::before {
        content: '';
        background-image: url('~@assets/images/home/icon_shiny2.svg');
        background-size: cover;
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }
  }
}

@media (min-width: 1200px) {
  .sectionFeatures {
    :global {
      .feature-container {
        display: flex;
        gap: 100px;
        margin-bottom: 160px;

        &.row-reverse {
          flex-direction: row-reverse;
        }
      }

      .feature-content {
        min-width: 600px;
        max-width: 600px;
        margin-bottom: 0;

        .sub-title {
          color: $color-primary;
          font-size: 22px;
          text-align: left;
          width: 460px;
          margin: 0 auto;
          margin-bottom: 8px;
        }

        .title {
          font-size: 40px;
          margin: 0 auto;
          margin-bottom: 4rem;
          width: 460px;
          text-align: left;
        }

        .content-detail {
          width: 460px;
          margin: 0 auto;
          p {
            text-align: left;
            font-size: 16px;
          }
        }
      }

      .feature-img {
        img {
          min-width: 960px;
          max-width: 960px;
          border-radius: 10px;
          box-shadow: 0 5px 20px rgba(40, 45, 78, 0.2);
        }
      }

      .start-text {
        font-size: 24px !important;
        justify-content: left;

        &::before {
          content: '';
          width: 24px;
          height: 24px;
        }
      }
    }
  }
}
</style>
